import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, combineLatest, of } from "rxjs";
import { Briefing } from "../../shared/types";
import { FilterModel } from "../../filter/filter.model";
import { debounceTime, distinctUntilChanged, shareReplay, startWith, switchMap } from "rxjs/operators";
import { filterBriefingDepartments, filterBriefingUsers } from "./filter.utils";

@Injectable()
export class BriefingFilterService {
	private readonly filterModel = inject(FilterModel);

	private readonly search$ = new BehaviorSubject("");

	filter$ = this.filterModel.filterPresentation$;

	search(text: string) {
		this.search$.next(text);
	}

	getFilteredBriefings(briefing: Briefing[]) {
		return combineLatest([
			this.search$.pipe(debounceTime(270), startWith(""), distinctUntilChanged()),
			this.filter$.pipe(startWith<{ id: string }[]>([])),
		]).pipe(
			switchMap(([search, departments]) => {
				return of(briefing).pipe(filterBriefingDepartments(departments), filterBriefingUsers(search));
			}),
			shareReplay(1),
		);
	}
}
